export default __webpack_public_path__ + "static/media/mostdelicios.cf5af951.png";